module.exports = __webpack_public_path__ + "static/media/key_gray.fff97321.svg";